import { Typography } from '@mui/material';
import type { Condition } from '@repo/api-gw-sdk';

import type { ResourcesScopeType } from '@/components/resourcesSelection/resourceSelectionDynamicViewer';
import type { Step } from '@/components/wizard/Step';
import { Wizard } from '@/components/wizard/Wizard';
import {
  createAllExcludedCondition,
  createAllIncludedCondition,
} from '@/types/advanceFilter';

import { BackupScopeResourcesEditor } from './backupScopeResourcesEditor';
export interface BackupScopeResourcesEditorState {
  condition?: Condition;
  resourcesScopeType: ResourcesScopeType;
  include: string[];
  exclude: string[];
}

const BackupScopeResourcesEditorFlow: Step<BackupScopeResourcesEditorState> = {
  name: 'Editor',
  Component: BackupScopeResourcesEditor,
};

interface BackupScopeResourcesWizardProps {
  condition?: Condition;
  resourcesScopeType: ResourcesScopeType;
  include?: string[];
  exclude?: string[];
  onSave: (
    condition: Condition,
    include: string[],
    exclude: string[]
  ) => Promise<void>;
  onAbort: () => void;
}

export default function BackupScopeResourcesWizard(
  props: BackupScopeResourcesWizardProps
) {
  const onFinish = async (state: BackupScopeResourcesEditorState) => {
    const condition =
      state.resourcesScopeType === 'allIncluded'
        ? createAllIncludedCondition()
        : state.resourcesScopeType === 'allExcluded'
          ? createAllExcludedCondition()
          : state.condition;

    if (condition) {
      await props.onSave(
        {
          ...condition,
        },
        state.include,
        state.exclude
      );
      return true;
    }

    return false;
  };

  return (
    <Wizard<BackupScopeResourcesEditorState>
      onAbort={props.onAbort}
      hideBackArrow={true}
      hideBorder={false}
      onFinish={onFinish}
      flow={[BackupScopeResourcesEditorFlow]}
      initialState={{
        condition: props.condition,
        resourcesScopeType: props.resourcesScopeType,
        include: props.include ?? [],
        exclude: props.exclude ?? [],
      }}
      title={'Edit resource scope'}
      subtitle={
        <Typography variant='body1'>
          Choose which resources are included in your discovery process.
          <br />
          Included resources are discovered, scanned, classified, and backed up
          if matched by a policy.
        </Typography>
      }
    />
  );
}
